export enum InstitutionalUserAuthModalStateEnum {
    SignIn,
    CodeValidation
}
